export const DEFAULT_COLOR = '#fff';

export const PRESET_COLORS = [
  '#fff',
  '#ffcc99',
  '#ffff99',
  '#ccffff',
  '#99cc00',
  '#ff6600',
  '#c0c0c0',
  '#ff99cc',
  '#7FFFD4',
  '#BAF73C',
  '#FFECDB',
  '#DCC6E0',
  '#F1A9A0',
  '#DADFE1',
  '#B2CCE5',
  '#E6CC22',
  '#F9BF3B',
  '#E7903C'
];




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/config/color-constants.ts